module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph4-60fa82d756c5d93d706f319a41a282b2.png";